export const SUPPORT_LINK = 'https://support.cian.ru/ru/knowledge_base/art/94/cat/179/';
export const PROFILE_URL = 'https://my.cian.ru/profile';
export const CONTENT_RATING_URL = 'https://www.cian.ru/reyting-rieltorov/?location=0&agent_id=';
export const RGR_CERTIFICATE_URL = 'https://hc.cian.ru/hc/ru/articles/4409480755348';
export const KOKON_CERTIFICATE_URL = 'https://hc.cian.ru/hc/ru/articles/5184413035924';
